import styled from '@emotion/styled'

import { DefaultValue } from '../../enums/defaultValue'
import { Themable } from '../../types/themable'
import { skeletonAnimation } from '../../utils/skeletonAnimation'
import { sizeToDimension } from '../Button'
import { Size as ButtonSize } from '../Button/types/size'

const DEFAULT_WIDTH = 150

interface SkeletonBoxProps extends Themable {
  fullWidth?: boolean
  width?: number
  size: ButtonSize
}

export const SkeletonButton = styled.div<SkeletonBoxProps>`
  height: ${({ size }) => sizeToDimension[size]}px;
  border-radius: ${DefaultValue.BorderRadius};
  ${({ width = DEFAULT_WIDTH }) => width && `width: ${width}px`};
  ${({ fullWidth }) => fullWidth && 'width: 100%'};
  ${skeletonAnimation()};
`
